import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { axiosInstance } from "../../lib/axios";

interface MemorySettings {
  display_name: string | null;
  instruction: string | null;
}

interface MemorySettingsResponse {
  results: MemorySettings;
}

interface UpdateMemorySettingsPayload {
  display_name?: string;
  instruction?: string;
}

const MEMORY_SETTINGS_QUERY_KEY = ["memory-settings"] as const;

export const useFetchMemorySettings = () => {
  return useQuery({
    queryKey: MEMORY_SETTINGS_QUERY_KEY,
    queryFn: () =>
      axiosInstance.get<MemorySettingsResponse>("/memory/settings"),
    select: (data) => data.data.results,
  });
};

export const useUpdateMemorySettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateMemorySettingsPayload) =>
      axiosInstance.put<{ success: boolean }>("/memory/settings", payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MEMORY_SETTINGS_QUERY_KEY });
    },
  });
};

export const useInvalidateMemorySettings = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({ queryKey: MEMORY_SETTINGS_QUERY_KEY });
};
